import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Shared "Return to Workspace" affordance for nested workspace screens
 * (Event editor, Artist page editor, Agreement dialog, etc.). Keeps the
 * user's active Artist workspace context because it's a plain React
 * Router link back to /workspace — the RoleProvider preserves activeArtistId.
 */
export default function ReturnToWorkspace({ testId = "return-to-workspace", className = "" }) {
    return (
        <Link
            to="/workspace"
            data-testid={testId}
            className={`inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-widest text-[#a3a3a3] hover:text-[#ff4400] ${className}`}
        >
            <ArrowLeft className="w-3 h-3" /> Return to Workspace
        </Link>
    );
}
